"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = unique;
function unique(a) {
    return a.filter((item, index, a) => a.indexOf(item) === index);
}
